export default function Wheelbarrow(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.0627 19.7993H26.0188V9.81177H2.2969V16.0001C2.29517 16.4926 2.39091 16.9807 2.5786 17.436C2.76629 17.8914 3.04223 18.3052 3.39051 18.6534C3.73879 19.0017 4.15253 19.2776 4.60791 19.4653C5.06329 19.653 5.5513 19.7488 6.04384 19.747H9.96051"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M31.0095 19.7991H23.5156"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M28.5156 24.7994V19.7991"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M9.78125 21.0526C9.78125 22.0464 10.176 22.9994 10.8787 23.7021C11.5814 24.4048 12.5344 24.7996 13.5282 24.7996C14.5219 24.7996 15.475 24.4048 16.1777 23.7021C16.8804 22.9994 17.2751 22.0464 17.2751 21.0526C17.2751 20.0589 16.8804 19.1058 16.1777 18.4031C15.475 17.7004 14.5219 17.3057 13.5282 17.3057C12.5344 17.3057 11.5814 17.7004 10.8787 18.4031C10.176 19.1058 9.78125 20.0589 9.78125 21.0526Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</svg>
	)
}
